import arrayToTree from 'array-to-tree'

const competenciasNormais = (state, getters) => {
  return getters.competenciasVisiveis.filter(o => !o.acumula)
}
const competenciasVisiveis = (state) => {
  return state.competenciaList.filter(o => o.visivel)
}

const centroCustolistTree = (state) => {
  if (!state.centroCustoList) {
    return []
  }
  return arrayToTree(state.centroCustoList
    .map(item => _.pick(item, ['id', 'parent_id', 'nome', 'user.id', 'user.name'])))
}


const indicadorlistTree = (state) => {
  if (!state.indicadorList) {
    return []
  }
  const indicadores = [...state.indicadorList]
  return arrayToTree(indicadores.map(item => _.pick(item, ['id', 'parent_id', 'nome'])))
}

const centroCustoParentList = (state) => {
  const list = collect([...state.centroCustoList])
  const parentIds = list.pluck('parent_id').all()
  return list.whereIn('id', parentIds).all()
}

export default {
  competenciasNormais, competenciasVisiveis, centroCustolistTree, indicadorlistTree, centroCustoParentList
}







// WEBPACK FOOTER //
// ./src/store/getters.js